import { render, staticRenderFns } from "./SupplementAmounts.vue?vue&type=template&id=6a3e28cc"
import script from "./SupplementAmounts.vue?vue&type=script&lang=js"
export * from "./SupplementAmounts.vue?vue&type=script&lang=js"
import style0 from "./SupplementAmounts.vue?vue&type=style&index=0&id=6a3e28cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports